(function () {
  'use strict';

  /* @ngdoc object
   * @name informacio.people
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.ajuntament.informacio.people', [
    'ui.router'
  ]);
}());
